function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useContext, useMemo } from 'react';
import styles from '../RecordCompareRecordObject.module.scss';
import { Column } from '../../Layout/RecordCompareLayout';
import useRecordLabel from '../../../hooks/useRecordCompareLabel';
import CompareContext from '../RecordCompareContext';
import RecordCompareStateContext from '../../../RecordCompareStateContext';
import PropertyTitle from '../RecordComparePropertyTitle';
import { injectIntl } from 'react-intl';
import getOr from '../../../../utils/getOr';
import I18n from '../../../../I18n/I18n/I18n';
var getTitle = getOr({})('ui:title');
function SelectCard(_ref) {
  var recordIndex = _ref.recordIndex,
    property = _ref.property,
    checked = _ref.checked,
    intl = _ref.intl;
  var _useContext = useContext(CompareContext),
    mergeRecord = _useContext.mergeRecord,
    propertyPrefix = _useContext.propertyPrefix;
  var _useContext2 = useContext(RecordCompareStateContext),
    mergeSelections = _useContext2.mergeSelections,
    setLastSelection = _useContext2.setLastSelection,
    selections = _useContext2.selections,
    showErrors = _useContext2.showErrors,
    records = _useContext2.records;
  var uiSchema = mergeRecord.uiSchema;
  var selectionId = propertyPrefix + property;
  var recordId = records[recordIndex].recordId;
  var hasSelection = useMemo(function () {
    return selections[selectionId] !== null && selections[selectionId] !== undefined;
  }, [selections, selectionId, recordIndex]);
  var handleChange = useCallback(function () {
    setLastSelection(recordIndex);
    mergeSelections(_defineProperty({}, selectionId, recordIndex));
  }, [setLastSelection, mergeSelections, recordIndex, selectionId]);
  var _useRecordLabel = useRecordLabel(recordIndex, property),
    label = _useRecordLabel.label,
    escape = _useRecordLabel.escape,
    isEmpty = _useRecordLabel.isEmpty,
    uri = _useRecordLabel.uri;
  var propUiSchema = uiSchema[property];
  var _getTitle = getTitle(propUiSchema),
    text = _getTitle.text;
  var cardLabel = useMemo(function () {
    if (isEmpty) {
      return intl.formatMessage({
        id: label
      }, {
        label: '[' + text + ']'
      });
    }
    return label;
  }, [isEmpty, label]);
  return /*#__PURE__*/React.createElement(Column, {
    className: isEmpty ? styles['empty'] : '',
    highlight: checked
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.card
  }, /*#__PURE__*/React.createElement(PropertyTitle, {
    checked: checked,
    property: property,
    recordIndex: recordIndex,
    required: true,
    error: showErrors && !hasSelection,
    labelFor: "".concat(recordId, "-").concat(property, "-").concat(recordIndex),
    handleChange: handleChange
  }), /*#__PURE__*/React.createElement("label", {
    style: {
      marginLeft: 'calc(16px + 1em)',
      color: '#4A4A4A',
      display: 'block'
    },
    id: "".concat(recordId, "-").concat(property, "-").concat(recordIndex, "-description"),
    for: "".concat(recordId, "-").concat(property, "-").concat(recordIndex),
    class: "auto-label auto-label-".concat(property, "-").concat(recordIndex)
  }, uri ? /*#__PURE__*/React.createElement("a", {
    href: uri,
    className: styles.download
  }, cardLabel, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, ' ', /*#__PURE__*/React.createElement(I18n, {
    i18n: cardLabel
  }))) : cardLabel, showErrors && !hasSelection ? /*#__PURE__*/React.createElement("div", {
    id: "".concat(recordId, "-").concat(property, "-").concat(recordIndex, "-error"),
    className: styles.error,
    "aria-atomic": true,
    "aria-live": 'polite'
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: intl.formatMessage({
      id: '@dm/components.record-compare.labels.error'
    }, {
      type: text
    })
  })) : null)));
}
export default injectIntl(SelectCard);